module.exports = __webpack_public_path__ + "down-arrow.af4eec202814d1d178743fd86a6e273a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/down-arrow.svg
// module id = 1136
// module chunks = 0